module.exports = __webpack_public_path__ + "img/CHILLER™ 30-Can Soft-Sided Portable Cooler.fd7b0792.jpg";